import { BaseEventTracking } from '/@/modules/core/app/models/abstracts/BaseEventTracking';
import { SegmentEvent } from '/@/integrations/segment/SegmentEvent';

export class AdvisorPortalPlanningReferralStarted extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.ADVISOR_PORTAL_PLANNING_REFERRAL_STARTED;

  entryPoint: string;

  constructor(entryPoint: string) {
    super();

    this.entryPoint = entryPoint;
  }
}
